<template>
    <!-- component is a multi template
    check for other variants -->
    <b-modal id="modal-change-address"
             hide-footer
             centered
             :title="modalTitle"
             size="lg"
             v-model="isVisible"
    >
        <div class="row">
            <div class="col-12">
                <template>
                    <div class="row d-flex justify-content-center">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-md-8 mt-2">
                                    <div class="form-group">
                                        <label for="street">{{ $t('cdb.subscriptions.street') }}</label>
                                        <input id="street" class="form-control" :placeholder="$t('cdb.subscriptions.street')" v-model="data.street"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 mt-2">
                                    <div class="form-group">
                                        <label for="number">{{ $t('cdb.subscriptions.house_number') }}</label>
                                        <input id="number" class="form-control" :placeholder="$t('cdb.subscriptions.house_number')" v-model="house_number"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4 mt-2">
                                    <div class="form-group">
                                        <label for="zip">{{ $t('cdb.subscriptions.postal_code') }}</label>
                                        <input id="zip" class="form-control" :placeholder="$t('cdb.subscriptions.postal_code')" v-model="postal_code"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mt-2">
                                    <div class="form-group">
                                        <label for="location">{{ $t('cdb.subscriptions.city') }}</label>
                                        <input id="location" class="form-control" :placeholder="$t('cdb.subscriptions.city')" v-model="city"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="row" v-if="error">
            <div class="col-12 text-danger">
                {{ error }}
            </div>
        </div>
        <div class="row mt-3 d-flex justify-content-end">
            <div class="col-12 text-right">
                <b-button variant="primary" class="mr-3" @click="abort">{{ $t('cdb.subscriptions.close') }}</b-button>
                <b-button variant="primary" @click="store" :disabled="disableSaveButton">{{ $t('cdb.subscriptions.save') }}</b-button>
            </div>
        </div>
    </b-modal>
    <!-- component is a multi template
    check for other variants -->
</template>

<script>
import { EventBus } from '../../event-bus';
import { BModal, BButton } from 'bootstrap-vue';

export default {
    name: 'ModalChangeAddressDefaultComponent',
    components: {
        BModal,
        BButton,
    },
    data() {
        return {
            isVisible: false,
            data: '',
            address: 1,
            disableSaveButton: false,
            error: '',
            title: ''
        }
    },

    mounted() {
        EventBus.$on('init-change-address', this.getData);
    },

    methods: {
        getData(data) {
            this.isVisible = true
            this.data = JSON.parse(JSON.stringify(data.address))
            this.title = data.title
        },

        abort(){
            this.isVisible = false
        },

        store() {
            this.$axios.put('api/v1/dashboard/update_address', {
                    'uuid': this.data.uuid,
                    'additional': this.additional,
                    'street': this.street,
                    'house_number': this.house_number,
                    'city': this.city,
                    'postal_code': this.postal_code,
                })
                .then(() => {
                    this.isVisible = false;
                    // Reload of the whole Site to reset other Modals too
                    this.$router.go();
                }).catch(error => {
                    this.error = error.response.data.message;
            });
        }
    },

    computed: {
        additional: {
            get() {
                return this.data.additional;
            },
            set(val) {
                this.data.additional = val;
            }
        },

        street: {
            get() {
                return this.data.street;
            },
            set(val) {
                this.data.street = val;
            }
        },

        house_number: {
            get() {
                return this.data.house_number;
            },
            set(val) {
                this.data.house_number = val;
            }
        },

        postal_code: {
            get() {
                return this.data.postal_code;
            },
            set(val) {
                this.data.postal_code = val;
            }
        },

        city: {
            get() {
                return this.data.city;
            },
            set(val) {
                this.data.city = val;
            }
        },
        modalTitle() {
            if(this.data) {
                return this.$t(`cdb.subscriptions.${this.title}`)
            } else
                return ''
        }
    },
}
</script>
